<template>
  <div>
    <b-card bg-variant="light" class="mb-2">
      <h6 class="booking-details-title">{{ item.label }}</h6>
      <b-card-text style="white-space: pre-line;">
        {{ item.description }}
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'TransferItemInfo',
  props: ['item']
}
</script>
